import React from "react";
import ReactDOM from "react-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import 'react-slideshow-image/dist/styles.css';
import "bootstrap-css-only/css/bootstrap.min.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "mdbreact/dist/css/mdb.css";
import "react-loading-skeleton/dist/skeleton.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-jinke-music-player/assets/index.css'
import "./index.css";
import "./style.css";
import './assets/css/EventsPage.css';

import "./assets/css/HomePage.css";
import "./assets/css/SapaDisdik.css";
import "./assets/css/Mobile.css";
import './assets/css/Ppdb.css';
import "./assets/css/Produk.css";
import "./assets/css/Programs.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import App from "./App";
import { withRouter } from "react-router-dom";
//Tes 1
import * as registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

registerServiceWorker.unregister();